export const GET_PRODUCT_BY_HANDLE = `
  query getProduct($handle:String){
    product(handle:$handle){
        availableForSale
        featuredImage {
        height
        src
        url
        width
        originalSrc
        id
        altText
        }
        handle
        id
        totalInventory
        compareAtPriceRange {
          maxVariantPrice {
              amount
              currencyCode
          }
        }
        priceRange {
          maxVariantPrice {
            amount
          }
          minVariantPrice {
            amount
          }
        }
        collections(first: 10) {
          nodes {
            id
          }
        }
        onlineStoreUrl
        productType
        publishedAt
        requiresSellingPlan
        tags
        title
        updatedAt
        vendor
        createdAt
        description
        descriptionHtml
        variants(first: 200) {
      edges {
        node {
          availableForSale
          title
          unitPrice {
            amount
            currencyCode
          }
          quantityAvailable
          requiresShipping
          id
          currentlyNotInStock
          barcode
          image {
            height
            src
            url
            width
            id
            originalSrc
            altText
          }
          priceV2 {
            amount
            currencyCode
          }
          selectedOptions {
            name
            value
          }
          sku
          product {
            id
            title
            productType
          }
        }
      }
    }
    }
  }
`;

export const GET_COLLECTIONS_BY_HANDLE_FILTER_BY_TAG = `
  query($query: String) {
    collections(first: 1, query: $query){
      nodes{
        products(first: 200) {
          nodes {
            id
            tags
            vendor
            title
            variants(first: 150) {
              nodes {
                title
                availableForSale
                quantityAvailable
                selectedOptions {
                  name
                  value
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const CREATE_CART = `
  mutation cartCreate {
    cartCreate {
      cart {
        checkoutUrl
        id
      }
    }
  }
`;

export const ADD_TO_CART_LINES = `
  mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      cart {
        id
        checkoutUrl
        cost {
          totalAmount {
            amount
            currencyCode
          }
          subtotalAmount {
            amount
            currencyCode
          }
          totalTaxAmount {
            amount
            currencyCode
          }
          totalDutyAmount {
            amount
            currencyCode
          }
        }
        lines(first: 100) {
          edges {
            node {
              id
              quantity
              merchandise {
                ... on ProductVariant {
                  availableForSale
                  title
                  unitPrice {
                    amount
                    currencyCode
                  }
                  quantityAvailable
                  requiresShipping
                  id
                  currentlyNotInStock
                  barcode
                  image {
                    height
                    src
                    url
                    width
                    id
                    originalSrc
                    altText
                  }
                  priceV2 {
                    amount
                    currencyCode
                  }
                  compareAtPrice {
                    amount
                    currencyCode
                  }
                  selectedOptions {
                    name
                    value
                  }
                  sku
                  product {
                    id
                    title
                    productType
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_CART_LINES = `
  query GetCartLines($id: ID!) {
    cart(id: $id) {
      id
      createdAt
      updatedAt
      cost {
        totalAmount {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        totalDutyAmount {
          amount
          currencyCode
        }
      }
      lines(first: 100) {
        edges {
          node {
            discountAllocations {
              discountedAmount {
                amount
              }
              ...Discounts
            }
            id
            quantity
            merchandise {
              ... on ProductVariant {
                availableForSale
                title
                unitPrice {
                  amount
                  currencyCode
                }
                quantityAvailable
                requiresShipping
                id
                currentlyNotInStock
                barcode
                image {
                  height
                  src
                  url
                  width
                  id
                  originalSrc
                  altText
                }
                priceV2 {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
                selectedOptions {
                  name
                  value
                }
                sku
                product {
                  id
                  title
                  productType
                }
              }
            }
          }
        }
      }
    }
  }

  fragment Discounts on CartDiscountAllocation {
    ... on CartCodeDiscountAllocation {
      code
    }
    ... on CartAutomaticDiscountAllocation {
      title
    }
    ... on CartCustomDiscountAllocation {
      title
    }
  }
`;

export const UPDATE_CART_LINE = `
  mutation UpdateCartLine($cartId: ID!, $lineId: ID!, $quantity: Int!) {
    cartLinesUpdate(
      cartId: $cartId
      lines: {
        id: $lineId
        quantity: $quantity
      }
    ) {
      cart {
        id
        lines(first: 100) {
          edges {
            node {
              discountAllocations {
                discountedAmount {
                  amount
                }
                ...Discounts
              }
              id
              quantity
              merchandise {
                ... on ProductVariant {
                  availableForSale
                  title
                  unitPrice {
                    amount
                    currencyCode
                  }
                  quantityAvailable
                  requiresShipping
                  id
                  currentlyNotInStock
                  barcode
                  image {
                    height
                    src
                    url
                    width
                    id
                    originalSrc
                    altText
                  }
                  priceV2 {
                    amount
                    currencyCode
                  }
                  compareAtPrice {
                    amount
                    currencyCode
                  }
                  selectedOptions {
                    name
                    value
                  }
                  sku
                  product {
                    id
                    title
                    productType
                  }
                }
              }
            }
          }
        }
        cost {
          totalAmount {
            amount
            currencyCode
          }
          subtotalAmount {
            amount
            currencyCode
          }
          totalTaxAmount {
            amount
            currencyCode
          }
          totalDutyAmount {
            amount
            currencyCode
          }
        }
      }
    }
  }

  fragment Discounts on CartDiscountAllocation {
    ... on CartCodeDiscountAllocation {
      code
    }
    ... on CartAutomaticDiscountAllocation {
      title
    }
    ... on CartCustomDiscountAllocation {
      title
    }
  }
  
`;

export const REMOVE_CART_LINE = `
  mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      cart {
        id
        cost {
          totalAmount {
            amount
            currencyCode
          }
          subtotalAmount {
            amount
            currencyCode
          }
          totalTaxAmount {
            amount
            currencyCode
          }
          totalDutyAmount {
            amount
            currencyCode
          }
        }
        lines(first: 100) {
          edges {
            node {
              discountAllocations {
                discountedAmount {
                  amount
                }
                ...Discounts
              }
              id
              quantity
              merchandise {
                ... on ProductVariant {
                  availableForSale
                  title
                  unitPrice {
                    amount
                    currencyCode
                  }
                  quantityAvailable
                  requiresShipping
                  id
                  currentlyNotInStock
                  barcode
                  image {
                    height
                    src
                    url
                    width
                    id
                    originalSrc
                    altText
                  }
                  priceV2 {
                    amount
                    currencyCode
                  }
                  compareAtPrice {
                    amount
                    currencyCode
                  }
                  selectedOptions {
                    name
                    value
                  }
                  sku
                  product {
                    id
                    title
                    productType
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  fragment Discounts on CartDiscountAllocation {
    ... on CartCodeDiscountAllocation {
      code
    }
    ... on CartAutomaticDiscountAllocation {
      title
    }
    ... on CartCustomDiscountAllocation {
      title
    }
  }
  
`;

export const GET_METAOBJECT_BY_HANDLE = `
  query ($handle: String!, $type: String!){
    metaobject(handle: {handle: $handle, type: $type}) {
      fields {
        value
        type
      }
    }
  }
`;

export const GET_IMAGE_BY_ID = `
  query ($id: ID!) {
    node(id: $id) {
      ... on MediaImage {
        image {
            url
            altText
          }
      }
    }
  }
`;
